import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/herbst',
  //   name: 'Autum',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Autum.vue')
  // },
  {
    path: '/impressum',
    name: 'Impressum',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/Impressum.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 700
        }
      }
    }
  }
})

// const getOffest = function() {
//   const {
//     mdAndDown
//   } = this.$vuetify.breakpoint
//   console.log("bla");
//   console.log(mdAndDown);
//   // return mdAndDown ? 400 : 300
//   return 700
// }

export default router